import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { AdminHeader, Card, Btn, Modal, Input, Textarea, Toggle, StatusBadge, Empty } from "@/components/admin/ui";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";

const EMPTY = { name: "", description: "", logo: "", order: 0, active: true };

export default function AdminBrands() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [f, setF] = useState(EMPTY);

  const load = () => api.get("/admin/brands").then(({ data }) => setItems(data.brands));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editId) await api.put(`/admin/brands/${editId}`, f); else await api.post("/admin/brands", f);
      toast.success("Saved"); setOpen(false); load();
    } catch (e) { toast.error(apiError(e)); }
  };
  const del = async (id) => { if (!window.confirm("Delete this brand?")) return; await api.delete(`/admin/brands/${id}`); load(); };

  return (
    <div>
      <AdminHeader title="Brands" subtitle={`${items.length} brands`} action={<Btn variant="accent" onClick={() => { setF(EMPTY); setEditId(null); setOpen(true); }} data-testid="add-brand-btn"><Plus className="h-4 w-4" /> Add Brand</Btn>} />
      <Card className="overflow-hidden">
        <table className="w-full text-sm text-left">
          <thead className="bg-slate-50 text-slate-500 text-xs uppercase"><tr><th className="p-3">Brand</th><th className="p-3">Order</th><th className="p-3">Status</th><th className="p-3 text-right">Actions</th></tr></thead>
          <tbody className="divide-y divide-slate-100">
            {items.map((b) => (
              <tr key={b.id} className="hover:bg-slate-50" data-testid={`brand-${b.slug}`}>
                <td className="p-3 font-medium text-slate-900">{b.name}</td>
                <td className="p-3 font-mono">{b.order}</td>
                <td className="p-3"><StatusBadge status={b.active ? "active" : "inactive"} /></td>
                <td className="p-3 text-right">
                  <button onClick={() => { setF({ ...b }); setEditId(b.id); setOpen(true); }} className="p-2 text-slate-500 hover:text-amber-600" data-testid={`edit-brand-${b.slug}`}><Pencil className="h-4 w-4" /></button>
                  <button onClick={() => del(b.id)} className="p-2 text-slate-500 hover:text-red-600"><Trash2 className="h-4 w-4" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {items.length === 0 && <Empty />}
      </Card>

      <Modal open={open} onClose={() => setOpen(false)} title={editId ? "Edit Brand" : "Add Brand"}>
        <form onSubmit={save} className="space-y-4">
          <Input label="Name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} testid="brand-name" />
          <Textarea label="Description" rows={2} value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} />
          <Input label="Logo URL" value={f.logo || ""} onChange={(e) => setF({ ...f, logo: e.target.value })} />
          <Input label="Display Order" type="number" value={f.order} onChange={(e) => setF({ ...f, order: Number(e.target.value) })} />
          <Toggle label="Active" checked={f.active} onChange={(v) => setF({ ...f, active: v })} />
          <Btn variant="accent" type="submit" className="w-full" data-testid="save-brand-btn">Save</Btn>
        </form>
      </Modal>
    </div>
  );
}
